export default {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tabletS: "630px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px",
}
